import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";

import {
    ComponentMenuBar,
    ComponentPdpa,
    ComponentProfilePrivilege,
    StyledContainerHome,
    StyledHome,
} from "@components";
import { PATH_PROFILE, PATH_TIER_DETAIL, enumNavigation } from "@configs";
import { ModuleHistory, ModulesBenefit, ModulesCoupon, ModulesReward } from "@modules";
import { selectAuth, selectMerchant, selectNotSaveLocal, setNavigationType } from "@redux";
import { RenderMeta } from "@utils";
import { Skeleton, Tabs } from "antd";
import { useTranslation } from "react-i18next";
import { LangDropdown } from "src/Components/LangDropdown";
import styled from "styled-components";

export const PagePrivilege = () => {
    //page hook
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const dispatch = useDispatch();
    const { t } = useTranslation();

    //page redux
    const { userInfo } = useSelector(selectAuth);
    const merchant = useSelector(selectMerchant);
    const { themes, memberShipTiers } = merchant || {};
    const { navigationType } = useSelector(selectNotSaveLocal);
    //page state
    const [showQrCode, setShowQrCode] = useState<boolean>(false);
    const [isLoading, setIsloading] = useState(false);

    const [xUserInfo, setXUserInfo] = useState<any>(userInfo);
    const [xMerchant, setXMerchant] = useState<any>(merchant);

    const setColor = userInfo?.memberTier?.color;

    const prefix = window.location.hostname.split(".")[0];

    const hexToRgb = (setColor: any) => {
        // Remove the '#' character if present
        setColor = setColor.replace("#", "");

        // Convert the hex code to RGB
        const r = parseInt(setColor.substring(0, 2), 16);
        const g = parseInt(setColor.substring(2, 4), 16);
        const b = parseInt(setColor.substring(4, 6), 16);

        return `linear-gradient(0deg,rgba(${r}, ${g}, ${b}, 0.2) 65%,rgba(${r}, ${g}, ${b}, 1) 100%)`;
    };

    const rgbColor = hexToRgb(setColor || "#FFFFFF");

    const handleToggleUnder = (values: enumNavigation) => {
        dispatch(setNavigationType(values));
    };

    const handleToggleQrCode = () => {
        setShowQrCode(!showQrCode);
    };

    const handleSwitchUserSetting = () => {
        // history.push(PATH_USER_SETTING);
        history.push(PATH_PROFILE);
    };

    const handleSwitchTier = () => {
        history.push(PATH_TIER_DETAIL);
    };

    const handleInitalQrCode = () => {
        setShowQrCode(false);
    };
    const renderedContent = useMemo(() => {
        switch (navigationType) {
            case enumNavigation.USER_POINT:
                return <ModulesReward />;
            case enumNavigation.BENEFIT:
                return <ModulesBenefit />;
            case enumNavigation.COUPON:
                return <ModulesCoupon under={navigationType} />;
            case enumNavigation.HISTORY:
                return <ModuleHistory />;
            case enumNavigation.COUPON_MERCHANT:
                return <ModulesCoupon under={navigationType} />;
            default:
                return <></>;
        }
    }, [navigationType]);

    const { TabPane } = Tabs;
    function callback(items: any) {
        setTab(items);
        handleToggleUnder(Number(items));
    }

    const path = window.location.pathname.split("/");
    let startTab = "1";
    if (path.length > 2) {
        if (id === "coupon") {
            startTab = "5";
        }
        if (id === "benefit") {
            startTab = "2";
        }
        if (id === "history") {
            startTab = "4";
        }
    }
    const [tab, setTab] = useState<string>(startTab);

    useEffect(() => {
        if (id) {
            if (id === "coupon") {
                setTab("5");
                handleToggleUnder(Number("5"));
            }
            if (id === "benefit") {
                setTab("2");
                handleToggleUnder(Number("2"));
            }
            if (id === "history") {
                setTab("4");
                handleToggleUnder(Number("4"));
            }
        } else {
            if (merchant?.securityConfig?.isPointDisplay) {
                setTab("1");
                handleToggleUnder(Number("1"));
            } else {
                setTab("2");
                handleToggleUnder(Number("2"));
            }
        }
    }, []);

    useEffect(() => {
        if (JSON.stringify(merchant) === JSON.stringify(xMerchant)) return;
        setXMerchant(merchant);
    }, [merchant]);

    useEffect(() => {
        if (JSON.stringify(userInfo) === JSON.stringify(xUserInfo)) return;
        setXUserInfo(userInfo);
        setIsloading(true);
        if (userInfo) {
            setIsloading(false);
        }
    }, [userInfo]);

    return (
        <StyledHome mainColor={themes?.themeColor!}>
            <RenderMeta title="Privilege Page" />
            <StyleCoporate color={rgbColor}>
                <div className="corp-lang">
                    <LangDropdown />
                </div>
                <StyleCoporateProfile>
                    <Skeleton
                        avatar
                        active
                        loading={isLoading}
                        title={{ width: 90 }}
                        paragraph={{ rows: 1, width: 171 }}
                    >
                        <ComponentProfilePrivilege
                            under={navigationType}
                            handleToggleUnder={handleToggleUnder}
                            userInfo={userInfo}
                            memberShipTiers={memberShipTiers || []}
                            themeColor={themes?.themeColor!}
                            handleToggleQrCode={handleToggleQrCode}
                            handleSwitchUserSetting={handleSwitchUserSetting}
                            handleSwitchTier={handleSwitchTier}
                        />
                    </Skeleton>
                </StyleCoporateProfile>
                <div className="layout-privilege">
                    <Tabs
                        animated
                        tabPosition="top"
                        defaultActiveKey={tab}
                        activeKey={tab}
                        onChange={callback}
                    >
                        {merchant?.securityConfig?.isPointDisplay && (
                            <TabPane tab={t("page.use_point")} key="1"></TabPane>
                        )}
                        {prefix !== "futurepark" && (
                            <TabPane tab={t("page.benefits")} key="2"></TabPane>
                        )}
                        <TabPane tab={t("page.coupons")} key="5"></TabPane>
                        <TabPane tab={t("page.history")} key="4"></TabPane>
                    </Tabs>
                    <StyledContainerHome className="home-nab-detail">
                        {renderedContent}
                    </StyledContainerHome>
                </div>
                <ComponentMenuBar />
                <ComponentPdpa />
            </StyleCoporate>
        </StyledHome>
    );
};

const StyleCoporate = styled.div`
    position: relative;
    /* top: 112px; */
    padding: 40px 0 0;
    background-color: #dfdfdf;
    // background: linear-gradient(0deg,rgba(0,0,0,0.2) 70%,rgba(0,0,0,0.9) 98%);
    // background: rgb(246,246,246);
    // background: linear-gradient(0deg,rgba(246,246,246,1) 68%,rgba(240,234,214,1) 100%);
    background: ${(props) => props.color};
    .corp-lang {
        position: absolute;
        z-index: 999;
        right: 0;
        top: 0;
        padding: 15px;
    }
    .layout-privilege {
        background-color: rgba(246, 246, 246, 1);
        border-top-right-radius: 16px;
        border-top-left-radius: 16px;
        height: 85dvh;
        overflow: scroll;
    }
    &:after {
        content: "";
        background-color: #f6f6f6;
        position: absolute;
        height: 112px;
        bottom: -112px;
        left: 0;
        width: 100%;
    }
`;

const StyleCoporateProfile = styled.div`
    .preview {
        background-color: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
        border-radius: 0 !important;
        border: none !important;
    }
    .ant-skeleton {
        // background-color: rgba(0, 0, 0, 0.4);
        padding: 12px;
        border-radius: 14px;
        margin: 12px;
        width: calc(100% - 24px);
        .ant-skeleton-header {
            span {
                width: 46px;
                height: 46px;
            }
        }
        .ant-skeleton-title {
            height: 10px;
            border-radius: 4px;
            margin-top: 3px;
            margin-bottom: 12px;
        }
        .ant-skeleton-paragraph {
            margin-top: 0;
            li {
                height: 10px;
                border-radius: 4px;
                margin-top: 0;
                margin-bottom: 8px;
            }
        }
    }
`;
